export default __webpack_public_path__ + "static/media/02-EXT-(1-2).ab0aaae8.jpg";